module.exports = [{
      plugin: require('../../../../../packages/gatsby-plugin-fisherman-customer-blog/gatsby-browser.js'),
      options: {"plugins":[],"layoutComponent":"/Users/NickLoeper/fisherman/fast/workspaces/v_1/website_envs/restaurants_61/src/components/WebsiteLayout.jsx"},
    }]
